export const File = 'file'

export const Directory = 'directory'

export const DirectoryExpanding = 'directory-expanding'

export const DirectoryExpanded = 'directory-expanded'

export const Symlink = 'symlink'

export const Socket = 'socket'

export const BlockDevice = 'block-device'

export const CharacterDevice = 'character-device'

export const Unknown = 'unknown'
